<template>
	<div class="login_item">
		<div class="user_login_box" v-show="!showLoginBox" v-if="!dialogVisible">
			<div class="login_img"></div>
			<div class="login_content" @keyup.enter="userLoginVerify">
				<el-tabs @tab-click="checkTabs" :value="loginActiveName" type="border-card">
					<el-tab-pane label="账号登录" class="panel-login" name="login">
						<el-form :model="formLabelAlign" ref="form">
							<el-form-item>
								<div class="custom-label">
									<img class="icon" src="../../static/img/login/icon_username.webp" />
									<div class="text">账号</div>
								</div>
								<el-input placeholder="请输入账号" v-model="formLabelAlign.userName" />
							</el-form-item>
							<el-form-item>
								<div class="custom-label">
									<img class="icon" src="../../static/img/login/icon_password.webp" />
									<div class="text">密码</div>
								</div>
								<el-input placeholder="请输入密码" v-model="formLabelAlign.passWord" type="password" />
							</el-form-item>
							<el-form-item>
								<div class="custom-label">
									<img class="icon" src="../../static/img/login/icon_verify.webp" />
									<div class="text">验证码</div>
								</div>
								<el-input placeholder="请输入验证码" v-model="formLabelAlign.verificationCode" />
								<img class="verification-img" :src="IndentyImg" alt="" @click="indentyajax" />
							</el-form-item>
							<el-form-item>
								<div class="text-link" @click="goToKeFu">忘记密码?</div>
							</el-form-item>
							<el-form-item>
								<el-button class="btn-login" type="primary" @click="userLoginVerify">立即登录 </el-button>
								<el-button class="btn-demo" plain @click="shiwan">试玩一下 </el-button>
							</el-form-item>
						</el-form>
					</el-tab-pane>
					<el-tab-pane label="用户注册" class="panel-register" name="register">
						<el-form :model="registerData">
							<el-form-item>
								<div class="custom-label">
									<img class="icon" src="../../static/img/login/icon_username.webp" />
									<div class="text">账号</div>
								</div>
								<el-input placeholder="请输入用户名" v-model="registerData.userID" />
							</el-form-item>
							<el-form-item>
								<div class="custom-label">
									<img class="icon" src="../../static/img/login/icon_password.webp" />
									<div class="text">登录密码</div>
								</div>
								<el-input
									type="password"
									placeholder="请输入密码"
									v-model="registerData.userPass"
									@input="checkPassword"
								/>
								<div v-if="!isPasswordValid" class="passwordValid">
									<!-- 密碼不符合規則： -->
									<ul>
										<li v-if="!hasDifferentFromUsername">* 为确保您的资金安全，密码请勿与账号相同。</li>
										<li v-if="!isLengthValid">* 密码長度應為 8-20 位。</li>
										<li v-if="!hasSpecialChar">* 为确保您的资金安全，密码须包含至少一种 @$!%*?&.+-/\ 特殊符号。</li>
										<li v-if="!hasRequiredCharacters">
											* 为确保您的资金安全，密码须包含使用英文字母大小写、数字中两种。
										</li>
									</ul>
								</div>
							</el-form-item>
							<el-form-item>
								<div class="custom-label">
									<img class="icon" src="../../static/img/login/icon_password.webp" />
									<div class="text">确认密码</div>
								</div>
								<el-input type="password" placeholder="请再次输入密码" v-model="registerData.confirmPass" />
							</el-form-item>
							<el-form-item>
								<div class="custom-label">
									<img class="icon" src="../../static/img/login/icon_pin.webp" />
									<div class="text">资金密码</div>
								</div>
								<el-input type="password" placeholder="请输入6-13位字母或数字" v-model="registerData.userPID" />
							</el-form-item>
							<el-form-item>
								<div class="custom-label">
									<img class="icon" src="../../static/img/login/icon_phone.webp" />
									<div class="text">手机号</div>
								</div>
								<el-input placeholder="请输入11位手机号码" v-model="registerData.PhoneNumber" />
							</el-form-item>
							<el-form-item>
								<div class="custom-label">
									<img class="icon" src="../../static/img/login/icon_verify.webp" />
									<div class="text">验证码</div>
								</div>
								<el-input placeholder="请输入验证码" v-model="registerData.userCode" />
								<img class="verification-img" :src="IndentyImg" alt="" @click="indentyajax" />
							</el-form-item>
							<el-button type="primary" @click="register">立即注册</el-button>
							<div class="text-link text-link--center" @click="setLoginActive">已有账号，前往登录</div>
						</el-form>
					</el-tab-pane>
				</el-tabs>
			</div>
		</div>
		<!--使用条款-->
		<el-dialog
			title="使用条款"
			:visible.sync="dialogVisible"
			width="960px"
			:modal-append-to-body="false"
			:close-on-click-modal="false"
			:show-close="false"
		>
			<div class="terms_con">
				<p>请贵使用者确认以下事项：</p>
				<p>1.贵使用者用以本网站注册之个人基本资料均与实际情况相符，且无冒用他人资料或伪造变造之情事。</p>
				<p>
					2.贵使用者于使用本网站提供之服务时，目前所在国家/地区并非中国大陆、香港、澳门、或台湾。　贵使用者兹确认登入本网站及使用本网站提供服务，并不违反目前所在之国家/地区之法令。
				</p>
				<p>
					3.贵使用者并未使用虚拟私人网路（VPN）或者其他任何不当手法连结至本网站，以致本网站无法确认使用者之真实目前所在国家/地区。
				</p>
				<p>
					4.贵使用者亦已知悉，如目前所在国家/地区禁止类似于本网站所提供服务时，本网站将拒绝提供服务；贵使用者并明确知悉使用违反前项规定所可能导致之法律制裁或其他风险。
				</p>
				<p>5.贵使用者兹确认不会藉本网站所提供服务用以从事任何违法活动。</p>
				<p>
					6.贵使用者了解及同意如本网站发现或知悉贵使用者于本网站有任何违法或违反使用者条款之行为，本网站将立即停止一切服务，视情节将账号停权。必要时将通报相关司法或警察机关。
				</p>
			</div>
			<div class="terms_footer">
				<div class="terms_btn" @click="agreeTerms">同意</div>
			</div>
		</el-dialog>
		<repassword :open="withdrawalDialog" />
	</div>
</template>
<script>
// 引用axios封装文件
import { postAjax, getAjax } from "../../util/ajax.js";
// 引用vuex文件
import { mapMutations, mapState } from "vuex";
import { getUserFavoritesLotteryList, getUserInfo } from "../../util/getdata";
import { timeFormatProcessing } from "../../util/common";
import { SysKey } from "../../util/sysconfig";
import repassword from "@/components/login/repassword.vue";

export default {
	data() {
		return {
			kfUrl: SysKey("KfCenterUrl").SysValue,
			formLabelAlign: {
				userName: "",
				passWord: "",
				verificationCode: "",
			},
			registerData: {
				userID: "",
				userPass: "",
				confirmPass: "",
				userPID: "",
				PhoneNumber: "",
				userCode: "",
			},
			userLogin: "", //用户名
			userPass: "", //密码
			userCode: "", //用户输入的二维码
			loginInfo: true, //登陆状态
			IndentyCode: "", //二维码唯一标示
			IndentyImg: "", //二维码图片
			terminalNum: null, //终端型号
			errUser: false, //用户名错误时显示错误信息
			errPass: false, //密码错误时显示错误信息
			errCode: false, //验证码错误时显示错误信息
			errText: "", //错误信息文本
			userToken: "", //用户标示token
			localhostHerf: "", //当前页网址
			loading: null,
			dialogVisible: false, //使用条款弹窗状态
			isPasswordValid: true,
			hasDifferentFromUsername: true,
			isLengthValid: true,
			hasSpecialChar: true,
			hasRequiredCharacters: null,
			withdrawalDialog: false,
			showLoginBox: false,
		};
	},
	components: {
		repassword,
	},
	computed: {
		...mapState({
			loginActiveName: state => {
				return state.loginActiveName;
			},
		}),
	},
	watch: {
		userCode(val) {
			this.userCode = val.replace(/[^0-9]/gi, "");
		},
		dialogVisible(val) {
			this.showLoginBox = val;
		},
	},
	created() {
		this.localhostHerf = window.location.hostname || document.domain;
		this.indentyajax();
		this.userPass = "";
		this.userCode = "";
	},
	methods: {
		checkPassword() {
			const username = this.registerData.userID;
			const lowercaseRegex = /^(?=.*[a-z])/;
			const uppercaseRegex = /^(?=.*[A-Z])/;
			const digitRegex = /^(?=.*\d)/;
			const specialCharRegex = /^(?=.*[@$!%*?&.\-+/\\])/;

			const lowercaseMatch = lowercaseRegex.test(this.registerData.userPass);
			const uppercaseMatch = uppercaseRegex.test(this.registerData.userPass);
			const digitMatch = digitRegex.test(this.registerData.userPass);
			const specialCharMatch = specialCharRegex.test(this.registerData.userPass);
			this.hasRequiredCharacters = [lowercaseMatch, uppercaseMatch, digitMatch].filter(Boolean).length;
			this.hasSpecialChar = specialCharMatch;
			this.hasDifferentFromUsername = this.registerData.userPass !== username;
			this.isLengthValid = this.registerData.userPass.length >= 8 && this.registerData.userPass.length <= 20;

			this.isPasswordValid =
				this.hasRequiredCharacters && this.hasSpecialChar && this.hasDifferentFromUsername && this.isLengthValid;
		},
		// 切换tabs
		checkTabs(tab, e) {
			this.checkLoginAndRegister({ active: tab.name });
		},
		// 忘记密码
		goToKeFu() {
			window.open(this.kfUrl, "_blank");
		},
		...mapMutations({
			changeLogin: "changeLogin",
			setLoginAfter: "setLoginAfter",
			checkLoginAndRegister: "checkLoginAndRegister",
		}),

		setLoginActive() {
			this.setLoginAfter({ state: "login" });
		},
		clareInput() {
			this.formLabelAlign.userName = "";
			this.formLabelAlign.passWord = "";
			this.formLabelAlign.verificationCode = "";
			this.registerData.userID = "";
			this.registerData.confirmPass = "";
			this.registerData.PhoneNumber = "";
			this.registerData.userCode = "";
			this.registerData.userPass = "";
			this.registerData.userPID = "";
		},
		// 请求验证码图片
		indentyajax() {
			let that = this;
			let url = "Api/Common/GetVerifyCode";
			getAjax(url, 1).then(function (data) {
				if (data.IsSucess) {
					that.IndentyImg = data.Data.ImgBase64;
					that.IndentyCode = data.Data.VcGuid;
				}
			});
		},
		// 显示提示框
		openMessAge(data) {
			this.$message.error(data);
		},
		_initOpenLoading() {
			this.loading = this.$loading({ background: "rgba(255, 255, 255, 0.2)" });
		},
		_initCloseLoading() {
			this.loading.close();
		},
		// 登陆成功
		openSuccess() {
			let that = this;
			this.$message({
				message: "登陆成功，即将跳转到首页",
				type: "success",
				duration: 1000,
				onClose: function () {
					if (that.$route.path !== "/home") {
						that.$router.push("/home");
					}
				},
			});
		},
		// 用户登录请求
		userLoginAjax() {
			// 判断终端
			if (
				navigator.userAgent.match(
					/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
				)
			) {
				var ua = window.navigator.userAgent.toLowerCase();
				if (ua.match(/MicroMessenger/i) == "micromessenger") {
					this.terminalNum = 3;
				} else {
					this.terminalNum = 2;
				}
			} else {
				this.terminalNum = 1;
			}
			const { userName, passWord, verificationCode } = this.formLabelAlign;
			var userinfo = {
				LoginName: userName,
				LoginPwd: passWord,
				Term: this.terminalNum,
				VCode: verificationCode,
				VCGuid: this.IndentyCode,
			};

			this._initOpenLoading();

			let url = "api/Login/In";
			postAjax(url, userinfo).then(data => {
				let that = this;
				this._initCloseLoading();
				if (data.IsSucess) {
					this.userToken = "Basic" + " " + data.Data.Token;
					// 将token存储到vuex
					this.changeLogin({ Authorization: this.userToken });
					this.openSuccess(); // 登录成功跳转home路由
					localStorage.setItem("alertState", "true");
					sessionStorage.clear();
					const username = that.formLabelAlign.userName;
					const lowercaseRegex = /^(?=.*[a-z])/;
					const uppercaseRegex = /^(?=.*[A-Z])/;
					const digitRegex = /^(?=.*\d)/;
					const specialCharRegex = /^(?=.*[@$!%*?&.\-+/\\])/;

					const lowercaseMatch = lowercaseRegex.test(that.formLabelAlign.passWord);
					const uppercaseMatch = uppercaseRegex.test(that.formLabelAlign.passWord);
					const digitMatch = digitRegex.test(that.formLabelAlign.passWord);
					const specialCharMatch = specialCharRegex.test(that.formLabelAlign.passWord);
					const hasRequiredCharacters = [lowercaseMatch, uppercaseMatch, digitMatch].filter(Boolean).length >= 2;
					const hasSpecialChar = specialCharMatch;
					const hasDifferentFromUsername = that.formLabelAlign.passWord !== username;
					const isLengthValid = that.formLabelAlign.passWord.length >= 8 && that.formLabelAlign.passWord.length <= 20;
					const isPasswordValid = hasRequiredCharacters && hasSpecialChar && hasDifferentFromUsername && isLengthValid;
					if (isPasswordValid == false) {
						this.withdrawalDialog = true;
						this.showLoginBox = true;
						return;
					}
					this.$store.commit("setLoginAfter", false); //关闭登录弹窗
					getUserInfo();
					this.lastLoginInfo();
					// 获取用户收藏彩种集合
					getUserFavoritesLotteryList();
				} else {
					if (data.Message) {
						//获取错误提示显示到页面
						this.errText = data.Message;
						if (data.Message == "验证码输入错误" || data.Message == "验证码过期") {
							this.errCode = true;
							this.formLabelAlign.verificationCode = "";
						} else if (data.Message == "用户不存在") {
							this.errUser = true;
						} else if (data.Message == "密码输入错误") {
							this.errPass = true;
							this.formLabelAlign.passWord = "";
							this.formLabelAlign.verificationCode = "";
						}

						this.openMessAge(this.errText);
						this.indentyajax();
					} else {
						this.openMessAge("获取地址失败，请刷新页面后重试");
					}
				}
			});
		},
		//注册
		register() {
			let path = this.$route.path;
			let that = this;
			let url = "api/User/DomainCreateUser";
			let data;
			if (path === "/userRegister") {
				data = {
					flag: that.regist,
					LoginName: that.registerData.userID,
					PassWord: that.registerData.userPass,
					SafetyPassWord: that.registerData.userPID,
					VCode: that.registerData.userCode,
					VCGuid: that.IndentyCode,
					PhoneNumber: that.registerData.PhoneNumber,
					Domain: that.localhostHerf,
				};
			} else {
				data = {
					LoginName: that.registerData.userID,
					PassWord: that.registerData.userPass,
					SafetyPassWord: that.registerData.userPID,
					VCode: that.registerData.userCode,
					VCGuid: that.IndentyCode,
					PhoneNumber: that.registerData.PhoneNumber,
					Domain: that.localhostHerf,
				};
			}
			if (that.registerData.userID == "") {
				that.openMessAge("请输入注册账号");
				return;
			} else if (that.registerData.userPass == "" || that.isPasswordValid == false) {
				that.openMessAge("登录密码请输入正确格式");
				return;
			} else if (that.registerData.confirmPass == "") {
				that.openMessAge("请再次输入注册密码");
				return;
			} else if (that.registerData.userPID == "") {
				that.openMessAge("请再次资金密码");
				return;
			} else if (that.registerData.PhoneNumber == "" || that.registerData.PhoneNumber.length != 11) {
				that.openMessAge("请输入11位手机号码");
				return;
			} else if (that.registerData.userCode == "") {
				that.openMessAge("请输入验证码");
				return;
			} else {
				that._initOpenLoading();
				postAjax(url, data).then(function (data) {
					that._initCloseLoading();
					if (data.Data) {
						localStorage.setItem("Authorization", "Basic" + " " + data.Data.Token);
						getUserInfo();
						that.openSuccess();
					} else {
						that.openMessAge(data.Message);
						that.indentyajax();
					}
				});
			}
		},
		// 试玩
		shiwan() {
			this._initOpenLoading();
			postAjax("/api/User/GetTmepUser").then(data => {
				this._initCloseLoading();
				if (data.IsSucess) {
					localStorage.setItem("Authorization", "Basic" + " " + data.Data.Token);
					localStorage.setItem("shiwan", true);
					getUserInfo();
					this.$message.success("登录成功，跳转首页中...");
					setTimeout(() => {
						if (this.$route.path !== "/home") {
							this.$router.push("/home");
						}
						this.$store.commit("setLoginAfter", false); //关闭登录弹窗
					}, 1000);
				} else {
					Message.error(data.Message);
				}
			});
		},
		lastLoginInfo() {
			let url = "Api/User/UserLoginLogInfo";
			let cxData = {
				StartTime: timeFormatProcessing(),
				EndTime: timeFormatProcessing(0, 1),
				PIndex: 1,
				PSize: 2,
			};
			postAjax(url, cxData)
				.then(data => {
					if (data.IsSucess) {
						this.$store.commit("setLastLogin", data.Data.rows[1].LoginTime);
					}
				})
				.catch(() => {
					this.loading = false;
				});
		},
		// input框获取焦点时隐藏错误提示
		hideErr() {
			this.errCode = false;
			this.errUser = false;
			this.errPass = false;
		},

		//用户登录
		userLoginVerify() {
			const { userName, passWord, verificationCode } = this.formLabelAlign;
			if (userName == "") {
				return this.openMessAge("账号不能为空");
			}
			if (passWord == "") {
				return this.openMessAge("密码不能为空");
			}
			if (verificationCode == "") {
				return this.openMessAge("验证码不能为空");
			}

			this.dialogVisible = true;
		},
		//同意条款
		agreeTerms() {
			this.userLoginAjax();
			this.dialogVisible = false;
		},
	},
};
</script>

<style lang="less">
.mask.login .el-tabs--border-card > .el-tabs__content {
	width: auto !important;
}
.login_item {
	.user_login_box {
		display: flex;
		width: 900px;
		height: 540px;

		.login_img {
			width: 450px;
			background-image: url("../../static/img/login/left_bg.webp");
			background-repeat: no-repeat;
			background-size: 100% 100%;
			text-align: center;
		}

		.login_content {
			width: 450px;
		}

		.el-tabs {
			border: none;
			box-shadow: none;
			border-radius: 0 18px 0 0;
		}

		.login_content .el-tabs--border-card > .el-tabs__header .el-tabs__item {
			line-height: 36px;
			margin: 0 0 0 0px;
			padding: 0 12px !important;
			border: none;
			border-top: 3px solid transparent;
			font-size: 16px;
		}

		.login_content .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
			border-top-color: #6455fe;
			color: #6455fe !important;
		}

		.mask .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active,
		.el-tabs--border-card > .el-tabs__header .el-tabs__item:not(.is-disabled):hover {
			color: #6455fe !important;
			background-color: white;
		}

		.el-tabs__nav-scroll {
			background-color: #6455fe;

			&::after {
				content: "";
				width: 100%;
				height: 100%;
				position: absolute;
				top: 0;
				left: 0;
				background-image: url("../../static/img/login/cover.webp");
				background-position: center;
				background-size: cover;
				background-repeat: no-repeat;
			}
		}

		.el-tabs__item {
			color: #fff !important;
		}

		.el-tabs__content {
			height: 500px;
			overflow-y: auto;
			padding: 40px 30px 30px 30px !important;
			background-color: white;
		}

		.el-form-item {
			position: relative;
			margin-bottom: 14px;

			.custom-label {
				width: 111px;
				height: 46px;
				display: flex;
				align-items: center;
				padding: 8px;
				padding-right: 0;
				position: absolute;
				top: 0;
				left: 0;
				z-index: 1;
				box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.08), inset 2.8px 2.8px 3px 0 rgba(0, 0, 0, 0.03);
				background-image: linear-gradient(to top, #f5f8fa, #f1f1f1, #f5f8fa);

				.icon {
					width: 28px;
					margin-right: 8px;
				}

				.text {
					font-size: 15px;
					color: #555;
				}
			}

			.el-input__inner {
				height: 46px;
				box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.08), inset 2.8px 2.8px 3px 0 rgba(0, 0, 0, 0.03);
				background-image: linear-gradient(to top, #f5f8fa, #f1f1f1, #f5f8fa);
				border: none;
				border-radius: 6px;
				padding-left: 123px;
				color: #555;
			}

			.verification-img {
				width: 80px;
				height: 36px;
				text-align: center;
				line-height: 36px;
				position: absolute;
				cursor: pointer;
				top: 50%;
				right: 4px;
				transform: translateY(-50%);
				z-index: 999;
				border-radius: 6px;
				background-color: #56b0f0;
			}
		}

		.el-button {
			width: 100%;
			height: 46px;
			margin: 0 auto 14px;
			font-size: 18px !important;
			color: #fff;
			&:hover {
				opacity: 0.9;
			}
			&.btn-demo {
				background-color: transparent;
				color: #6455fe;
				margin-left: 0 !important;
				border: 1px solid #6455fe;
			}
		}

		.el-button--primary {
			color: #fff;
			border: none;
			background-image: linear-gradient(to top, #746eff 100%, #645fff 100%, #613bf9 100%);
			background-size: cover;
			background-repeat: no-repeat;
			position: relative;
		}

		.el-button--primary::after {
			content: "";
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0;
			left: 0;
			// background-image: url("../../static/img/button_cover.webp");
			background-position: center;
			background-size: cover;
			background-repeat: no-repeat;
		}

		.panel-login {
			width: 340px;
			margin: 17px auto 0;
		}

		.user_login_itembox {
			position: relative;
			padding-bottom: 30px;
		}

		.user_login_itembox input {
			position: relative;
			display: inline-block;
			width: 100%;
			height: 54px;
			padding-left: 52px;
			outline: none;
			font-size: 14px;
			line-height: 42px;
			border-radius: 27px;
			border: solid 1px #8e8e8e;
			z-index: 1;
		}

		.user_login_itembox input::placeholder {
			color: #8e8e8e;
		}

		.user_login_itembox > p {
			padding: 6px 0;
			text-align: left;
			padding-left: 130px;
			color: #c93030;
			position: absolute;
			bottom: 0;
			left: 0;
			font-size: 14px;
			display: none;
		}

		.return__error p {
			display: block;
		}

		.user_login_btnbox {
			text-align: center;
		}

		.user_login_btnbox > button {
			width: 100%;
			height: 54px;
			background-color: #d86556;
			border-radius: 27px;
			border: none;
			font-size: 18px;
			color: #ffffff;
			cursor: pointer;
		}

		.user_login_btnbox > button:hover {
			opacity: 0.9;
		}

		.user_login_goto {
			text-align: center;
			width: 100%;
			font-size: 14px;
			margin-top: 15px;
			color: #707b83;
			overflow: hidden;
			margin-bottom: 9px;
		}

		.user_login_goto > .user_goto_other {
			color: #707b83;
		}

		.user_login_goto > .user_goto_other:hover {
			text-decoration: underline;
			color: #167e77;
		}

		.user_login_goto > span {
			margin: 0 5px;
		}

		/* 验证码 */

		.indenty_code input {
			padding: 3px 10px;
			line-height: 30px;
		}

		.indenty_code_box {
			display: inline-block;
			position: relative;
		}

		.indenty_code_box > input {
			width: 170px;
			border-radius: 10px;
		}

		.indenty_code_btn {
			float: right;
			width: 132px;
			height: 44px;
			margin-left: 8px;
			cursor: pointer;
		}

		.indenty_code_btn > img {
			width: 100%;
			height: 54px;
			border-radius: 10px;
		}

		.userclass {
			display: inline-block;
			position: absolute;
			top: 7px;
			left: 15px;
			font-size: 26px;
			color: #999999;
			z-index: 2;
		}

		.pasclass {
			display: inline-block;
			position: absolute;
			top: 6px;
			left: 16px;
			font-size: 26px;
			color: #999999;
			z-index: 2;
		}

		.el-carousel__item {
			font-size: 0;
			border-top-left-radius: 10px;
			border-bottom-left-radius: 10px;
		}

		.text-link {
			color: #555;
			cursor: pointer;
			font-size: 14px;
			text-align: right;

			&--center {
				text-align: center;
			}
		}
	}

	.el-dialog {
		.el-dialog__title {
			color: #fff;
		}

		.terms_con {
			line-height: 25px;
			padding: 0 10px;

			p {
				margin-bottom: 15px;
				color: #888;

				&:first-child {
					text-indent: 0;
				}
			}
		}

		.terms_footer {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 100%;
			height: 50px;
			margin-top: 30px;

			.terms_btn {
				width: 90px;
				height: 40px;
				line-height: 40px;
				text-align: center;
				cursor: pointer;
				color: #fff;
				border-radius: 3px;
				font-size: 16px;
				transition: all 0.3s;
				background-image: linear-gradient(to top, #746eff 100%, #645fff 100%, #613bf9 100%);

				&:hover {
					opacity: 0.9;
				}
			}
		}
	}
}
.passwordValid {
	color: red;
	font-size: 12px;
	margin-top: 6px;
	li {
		line-height: 14px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/login/login_item.vue